import React, { useState } from 'react';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { SimpleModal, errorText } from './SimpleModal';
import { REPORT_REASONS } from '../data/reportReasons';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReportContentModal = ({ bookId, bookTitle, token, isDarkMode, onClose }) => {
  const [reasons, setReasons] = useState([]);
  const [comment, setComment] = useState('');
  const [state, setState] = useState({ saving: false, error: '', done: '' });
  const toggle = (id) => {
    setState((s) => ({ ...s, error: '' }));
    setReasons(reasons.includes(id) ? reasons.filter((r) => r !== id) : [...reasons, id]);
  };

  const submit = async () => {
    if (!reasons.length) return setState({ ...state, error: 'Marque ao menos um motivo' });
    setState({ saving: true, error: '', done: '' });
    try {
      const { data } = await axios.post(`${API}/reports`, { book_id: bookId, reasons, comment }, { headers: { Authorization: `Bearer ${token}` } });
      setState({ saving: false, error: '', done: data.message });
    } catch (err) {
      setState({ saving: false, error: errorText(err, 'Não foi possível enviar a denúncia'), done: '' });
    }
  };

  const muted = isDarkMode ? '#9ca3af' : '#4a5568';
  return (
    <SimpleModal title="Denunciar conteúdo" onClose={onClose} testId="report-modal" dark={isDarkMode} maxWidth={560}>
      {!token ? (
        <p data-testid="report-login-required" style={{ color: muted }}>Faça login para denunciar um conteúdo.</p>
      ) : state.done ? (
        <p data-testid="report-success" style={{ color: '#38a169', fontWeight: 600, padding: '1rem 0', textAlign: 'center' }}>{state.done}</p>
      ) : (
        <>
          <p style={{ color: muted, fontSize: '0.85rem', marginBottom: '0.75rem' }}>Livro: <strong>{bookTitle}</strong>. Marque o(s) motivo(s):</p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {REPORT_REASONS.map((r) => (
              <label key={r.id} data-testid={`report-reason-${r.id}`} style={{ display: 'flex', gap: '0.6rem', alignItems: 'flex-start', cursor: 'pointer', fontSize: '0.85rem', lineHeight: 1.35,
                padding: '0.5rem 0.6rem', borderRadius: 8, border: `1px solid ${reasons.includes(r.id) ? '#e53e3e' : (isDarkMode ? '#374151' : '#e2e8f0')}` }}>
                <input type="checkbox" checked={reasons.includes(r.id)} onChange={() => toggle(r.id)} style={{ marginTop: 3, accentColor: '#e53e3e' }} />
                <span><strong>{r.label}:</strong> <span style={{ color: muted }}>{r.desc}</span></span>
              </label>
            ))}
          </div>
          <textarea value={comment} onChange={(e) => setComment(e.target.value)} maxLength={3000} rows={3} placeholder="Comentário (opcional): descreva o problema e, se possível, a página"
            data-testid="report-comment-input" style={{ width: '100%', marginTop: '0.75rem', border: `1px solid ${isDarkMode ? '#374151' : '#e2e8f0'}`, borderRadius: 8, padding: '0.75rem',
              fontSize: '0.9rem', background: isDarkMode ? '#111827' : 'white', color: 'inherit', resize: 'vertical' }} />
          {state.error && <p data-testid="report-error" style={{ color: '#e53e3e', fontSize: '0.85rem', marginTop: '0.5rem' }}>{state.error}</p>}
          <Button onClick={submit} disabled={state.saving} style={{ width: '100%', marginTop: '1rem', background: '#e53e3e', color: 'white' }} data-testid="report-submit-btn">
            {state.saving ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Enviar denúncia'}
          </Button>
        </>
      )}
    </SimpleModal>
  );
};
